import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';

// Debug: Log environment variables (only in dev)
if (import.meta.env.DEV) {
  console.log('Environment variables:', {
    VITE_COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    VITE_COGNITO_CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_ID,
    VITE_AWS_REGION: import.meta.env.VITE_AWS_REGION,
    VITE_API_ENDPOINT: import.meta.env.VITE_API_ENDPOINT,
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
